module.exports = __webpack_public_path__ + "img/29.537f691b.jpg";